export const EntityCreationWizardRoutes = {
  DONE: '/done',
};
